<template>
  <div class="audit-create">
    <div class="topbar">
        <div
          class="back"
          @click="handleBack"
        >
          <slot name="back-btn" >
            <yxt-svg
              width="16px"
              height="16px"
              icon-class="page-header-back-arrow"
            />
            <span class="back-text">{{info.baseInfo && info.baseInfo.tmplName}}{{$t('pc_audit')}}</span>
          </slot>
        </div>
      <div class="steps">
        <div
          v-for="(it, i) in steps"
          :key="it.key"
          class="step"
          :class="[
            activeIndex === i ? 'text-26' : 'text-8c',
            {
              active: activeIndex === i
            }
          ]"
        >
          <div class="title">
            <svg
              class="icon"
              v-if="activeIndex > i"
              width="21px"
              height="20px"
              viewBox="0 0 21 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                transform="translate(4.048087, 4.000000)"
                fill="#436BFF"
              >
                <path
                  d="M2.18256578,4.79025433 C2.24114721,4.73167568 2.33612647,4.73167568 2.39470789,4.79025433 L4.93988286,7.33530841 L9.60753964,2.66893398 C9.66612106,2.61035534 9.76110032,2.61035534 9.81968175,2.66893398 L10.6682502,3.51746212 C10.7268316,3.57604076 10.7268316,3.67101551 10.6682502,3.72959415 L5.04648427,9.35109307 C4.98790284,9.40967171 4.89292359,9.40967171 4.83434216,9.35109307 L1.33399734,5.8509145 C1.27541592,5.79233585 1.27541592,5.69736111 1.33399734,5.63878246 L2.18256578,4.79025433 Z"
                  id="路径"
                ></path>
              </g>
            </svg>
            <i
              v-else
              class="icon"
              :class="[
              'bg-gray-4',
              {
                active: activeKey === it.key,
                'color-white': activeKey === it.key
              }
            ]"
            >{{it.key}}</i>
            <span class="name">
              {{it.name}}
            </span>
          </div>
          <yxt-svg
            class="arrow"
            width="16px"
            height="16px"
            icon-class="icons/arrow-right"
          />
        </div>
      </div>
      <div class="none"></div>
    </div>
    <div
      class="step-con yxt-layout__root"
      v-loading="loading"
    >
      <StepTwo
        ref="stepTwoRef"
        v-if="activeIndex === 0"
        :connects="info.connects"
        :node-list="info.nodeList"
        :tmpl-code="tmplCode"
        :is-edit="isEdit"
      />
      <StepEnd
        ref="stepEndRef"
        v-if="activeIndex === 1"
        :tmpl-setting="info.tmplSetting"
        :is-edit="isEdit"
      />
    </div>
    <div class="audit-footer">
      <yxt-button
        @click="handlePrev"
        v-if="activeIndex > 0"
      >{{$t('pc_prev_btn')}}</yxt-button>
      <yxt-button
        :disabled="loading"
        type="primary"
        v-if="activeIndex < 1"
        @click="handleNext"
      >{{$t('pc_next_step')}}</yxt-button>
      <yxt-button
        v-else
        :loading="confirmPading"
        @click="handleOk"
        type="primary"
      >{{$t('pc_save')}}</yxt-button>
    </div>
  </div>
</template>

<script>

import { permissionRole, functionCode } from '../constants';
import { getAuditTemplateInfo, putAuditTemplateInfo, postAuditTemplateInfo } from './service';
import StepTwo from './components/step-two.vue';
import StepEnd from './components/step-end.vue';

export default {
  name: 'YxtbizAuditCenter',
  components: {
    StepTwo,
    StepEnd
  },
  eventList: [
    // 组件里抛出的事件名，需要开发者自己梳理
    {
      type: 'success', // 具体的抛出的事件名
      handler: 'handleAuditSuccess', // 事件处理函数
      label: '审核流程保存成功' // 事件描述
    }
  ],
  provide() {
    return {
      functionCode: this.$props.functionCode || functionCode,
      dataPermissionCode: this.$props.dataPermissionCode || this.$props.permissionRole || permissionRole,
      disableSponsor: !!this.$props.disableSponsor
    };
  },
  props: {
    tmplCode: String,
    projId: String,
    functionCode: String,
    dataPermissionCode: String,
    disableSponsor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      activeIndex: 0,
      steps: [
        {
          key: 1,
          name: this.$t('pc_setp_design')
        },
        {
          key: 2,
          name: this.$t('pc_more_seting')
        }
      ],
      info: {
        baseInfo: {},
        tmplSetting: {},
        connects: {},
        nodeList: {}
      },
      confirmPading: false,
      isEdit: null
    };
  },

  computed: {
    activeKey() {
      return this.steps[this.activeIndex].key;
    }
  },
  mounted() {
    console.debug('getTmplInfo');
    this.getTmplInfo();
  },
  methods: {
    async getTmplInfo() {
      try {
        this.loading = true;
        if (!this.projId || !this.tmplCode) {
          console.error('projId 或者 tmplCode 未传', {props: this.$props});
          throw new Error('projId 或者 tmplCode 未传');
        }
        const info = await getAuditTemplateInfo(this.projId, this.tmplCode);
        if (info && info.baseInfo && info.nodeList) {
          this.info = info;
          this.isEdit = true;
          return;
        }
        this.isEdit = false;
      } catch (e) {
        console.error(e);
        this.isEdit = false;
        // error
        let msg = '审核中心服务出现问题了，请重试！';
        if (e) {
          if (e.error && e.error.message) {
            msg = e.error.message;
          }
          if (e.message) {
            msg = e.message;
          }
        }
        this.$message.error(msg);
      } finally {
        this.loading = false;
      }
    },
    async handleNext() {
      try {
        switch (this.activeIndex) {
          case 0: {
            const ret = await this.$refs.stepTwoRef.validateForm();
            if (ret === false) {
              return;
            }
            this.info = {
              ...this.info,
              ...ret
            };
          }
            break;
        }
        this.activeIndex += 1;
      } catch (e) {
        console.debug(e);
        // error
        const msg = typeof e === 'string' ? e : e.message;
        this.$message.error(msg);
      }
    },
    handlePrev() {
      switch (this.activeIndex) {
        case 1: {
          const ret = this.$refs.stepEndRef.getData();
          this.info.tmplSetting = ret;
        }
          break;
      }
      this.activeIndex -= 1;
    },
    async handleBack() {
      try {
        await this.$confirm('', this.$t('pc_tmp_back_tip'), {
          type: 'warning'
        });
        this.$router.back();
      } catch (e) {
        if (e === 'cancel') return;
        // error
        this.$message({
          showClose: false,
          message: e.message,
          type: 'error'
        });
      }
    },
    async handleOk() {
      try {
        await this.$confirm(this.$t('pc_tmp_tip_warn'), this.$t('pc_save_ask'), {
          type: 'warning'
        });
        this.confirmPading = true;
        const ret = await this.$refs.stepEndRef.validateForm();
        if (ret === false) {
          return;
        }
        this.info.tmplSetting = ret;
        const { tmplSetting, nodeList: nodes, connects } = this.info;
        // hack
        const nodeList = nodes.map(it => {
          const { appters, userGroup, ...others } = it;
          if (!appters && !userGroup) return others;
          const arry = appters ? appters.filter(m => (m.userId || m.id)) : [];
          if (arry.length > 0 && it.auditPersType !== 2) {
            others.appters = arry.map(n => (n.userId || n.id));
          }
          // 只有开始节点有用户组userGroup
          const arryGroup = userGroup ? userGroup.filter(m => m.id) : [];
          if (arryGroup.length > 0 && it.auditPersType !== 2) {
            others.userGroup = arryGroup.map(n => {
              return n.id;
            });
          }
          return others;
        });
        if (this.isEdit === true) {
          await putAuditTemplateInfo(this.projId, this.tmplCode, {
            tmplSetting,
            nodeList,
            connects
          });
        } else {
          await postAuditTemplateInfo({
            tmplSetting,
            nodeList,
            connects,
            projId: this.projId,
            tmplCode: this.tmplCode
          });
        }
        const msg = this.$t('pc_edit_success');
        this.$message.success(msg);
        this.$emit('success', msg);
        this.$emit('getFlowPath', {tmplSetting, nodeList, connects });
      } catch (e) {
        if (e === 'cancel') return;
        console.error(e);
        // error
        const msg = typeof e === 'string' ? e : e.message;
        this.$message.error(msg);
        this.$emit('error', msg);
      } finally {
        this.confirmPading = false;
      }
    }
  }

};
</script>

<style scoped>
.audit-create /deep/ .yxt-form-item__content {
  max-width: 524px;
}
</style>
<style>
foreignObject#title{
  pointer-events: none;
}
foreignObject#label{
  pointer-events: none;
}
foreignObject#radio-text{
  pointer-events: none;
}
.ell {
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style scoped lang="scss">
.audit-create {
  height: 100%;
  min-height: 600px;
  display: flex;
  flex-direction: column;
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 24px;
}

.step-con {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: calc(100% - 56px * 2);
  padding: 12px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}

.back-text {
  margin-left: 15px;
  font-weight: 500;
}

.steps {
  display: flex;
  align-items: center;

  .step {
    display: inline-flex;
    align-items: center;
    &:not(:last-child) {
      margin-right: 10px;
    }
    .title {
      display: inline-flex;
      align-items: center;
      white-space: nowrap;
    }
    svg.icon{
      background: #F0F6FF;
    }
    .icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      margin-right: 8px;
      font-style: normal;
      border-radius: 50%;
      &.active {
        background-color: var(--color-primary);
      }
    }
    .arrow {
      display: inline-flex;
      align-items: center;
      margin-left: 10px;
    }
    &:last-child {
      .arrow {
        display: none!important;
      }
    }
    &.active {
      .name {
        font-weight: 500;
      }
    }
  }
}

.back {
  display: flex;
  align-items: center;
}

.audit-footer {
  display: flex;
  justify-content: center;
  padding: 12px 0;
  background: #fff;
  box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.08);
}
</style>
